(function () {
    let infiniteObserver = null;
    let canFetch = true;
    let currentlyObserved = null;
    let currentPage = 1;
    const fetchedPages = new Set();

    const loader = document.getElementById('paagination_loader');

    function getProductList() {
        return (
            document.querySelector('.grid.product-grid') ||
            document.getElementById('product-grid') ||
            document.querySelector('.ProductList.ProductList--grid.Grid')
        );
    }

    function getPagination() {
        return document.querySelector('.pagination-wrapper') || document.querySelector('.pagination');
    }

    function getLastGridItem(productList) {
        const selectors = ['.grid__item', '.grid_item', 'li.grid__item', 'li.grid_item', '.Grid__Cell', '.grid__cell'];
        for (let sel of selectors) {
            const nodes = productList.querySelectorAll(sel);
            if (nodes.length) return nodes[nodes.length - 1];
        }
        return productList.lastElementChild;
    }

    function findNextPageLink(pagination) {
        const relNext = pagination?.querySelector("a[rel='next']");
        if (relNext) return relNext;

        const anchors = pagination ? pagination.querySelectorAll("a[href*='page=']") : [];
        for (let a of anchors) {
            const match = a.href.match(/page=(\d+)/);
            if (match && parseInt(match[1]) > currentPage) return a;
        }
        return null;
    }

    function initInfiniteScroll() {
        if (infiniteObserver) return; // 🛡 safety

        const productList = getProductList();
        const pagination = getPagination();
        if (!productList) return;

        infiniteObserver = new IntersectionObserver(
            async (entries) => {
                for (const entry of entries) {
                    if (!entry.isIntersecting || !canFetch) continue;

                    const nextBtn = findNextPageLink(pagination);
                    if (!nextBtn) {
                        infiniteObserver.disconnect();
                        infiniteObserver = null;
                        return;
                    }

                    const nextUrl = new URL(nextBtn.href, location.origin).toString();
                    if (fetchedPages.has(nextUrl)) return;

                    try {
                        canFetch = false;
                        loader && (loader.style.display = 'block');

                        const res = await fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
                        const html = await res.text();
                        const doc = new DOMParser().parseFromString(html, 'text/html');

                        const newProducts = doc.querySelector('.grid.product-grid') || doc.getElementById('product-grid');

                        if (newProducts) {
                            const beforeCount = productList.children.length;
                            productList.insertAdjacentHTML('beforeend', newProducts.innerHTML);

                            // insertAdjacentHTML doesn't execute <script> tags, so re-create
                            // them for the newly inserted cards (needed for the RTS badge JS).
                            Array.from(productList.children)
                                .slice(beforeCount)
                                .forEach((node) => {
                                    node.querySelectorAll('script').forEach((oldScript) => {
                                        const newScript = document.createElement('script');
                                        for (const attr of oldScript.attributes) {
                                            newScript.setAttribute(attr.name, attr.value);
                                        }
                                        newScript.textContent = oldScript.textContent;
                                        oldScript.replaceWith(newScript);
                                    });
                                });

                            window.initAll && requestIdleCallback(() => window.initAll(productList));
                            requestAnimationFrame(() => {
                                typeof initCardSwiperTouch === 'function' && initCardSwiperTouch();
                            });
                        }

                        const newPagination = doc.querySelector('.pagination-wrapper') || doc.querySelector('.pagination');
                        if (newPagination && pagination) pagination.innerHTML = newPagination.innerHTML;

                        fetchedPages.add(nextUrl);
                        currentPage++;

                        loader && (loader.style.display = 'none');
                        canFetch = true;

                        infiniteObserver.unobserve(currentlyObserved);
                        currentlyObserved = getLastGridItem(productList);
                        currentlyObserved && infiniteObserver.observe(currentlyObserved);
                    } catch (e) {
                        console.error('InfiniteScroll error:', e);
                        canFetch = true;
                        loader && (loader.style.display = 'none');
                    }
                }
            },
            { rootMargin: '300px' }
        );

        currentlyObserved = getLastGridItem(productList);
        currentlyObserved && infiniteObserver.observe(currentlyObserved);
    }

    function resetInfiniteScroll() {
        infiniteObserver?.disconnect();
        infiniteObserver = null;

        canFetch = true;
        currentPage = 1;
        fetchedPages.clear();
        currentlyObserved = null;

        requestAnimationFrame(initInfiniteScroll);
    }

    // 🚀 FIRST LOAD
    document.addEventListener('DOMContentLoaded', resetInfiniteScroll);

    // ♻️ FILTER / SORT / AJAX RESET
    document.addEventListener('ajaxinate:loaded', resetInfiniteScroll);
    document.addEventListener('kymee:collection:reset', resetInfiniteScroll);
})();